import { useNavigate } from 'react-router-dom'

import { Link, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useSyncIssueUrls } from 'modules/integrations/hooks/useSyncIssueUrls'

export const IntegrationSettingsLink = () => {
  const { marketplaceIntegration, companyId } = usePrivateIntegrationsSyncContext()
  const navigate = useNavigate()

  const { integrationSettingsUrl } = useSyncIssueUrls({
    datoId: marketplaceIntegration?.datoId,
    companyId,
  })

  if (!integrationSettingsUrl) return null

  return (
    <Link.Touchable onClick={() => navigate(integrationSettingsUrl)}>
      <Text.Normal underlined color="grey800" size="200" weight="medium">
        {i18n.t('integrations.footer.validations_sidepanel_title')}
      </Text.Normal>
    </Link.Touchable>
  )
}
